export enum SendinblueEmailEvent {
	REQUEST = 'request',
	CLICK = 'click',
	DEFERRED = 'deferred',
	DELIVERED = 'delivered',
	SOFT_BOUNCE = 'soft_bounce',
	HARD_BOUNCE = 'hard_bounce',
	COMPLAINT = 'complaint',
	UNIQUE_OPENED = 'unique_opened',
	OPENED = 'opened',
	INVALID_EMAIL = 'invalid_email',
	BLOCKED = 'blocked',
	ERROR = 'error',
	UNSUBSCRIBED = 'unsubscribed',
}
